import "./styles.scss";

import React from "react";

const Banner = () => {
  return (
    <div className="blog-main__banner">
      <h2>
        <span>Inwestuj</span> w swój rozwój. <span>Zadbaj</span> o swoje zdrowie
        psychiczne.{" "}
      </h2>
      <p>
        Zdrowie psychiczne to fundament szczęśliwego i spełnionego życia. Nasz
        blog to{" "}
        <strong>
          źródło wiedzy i inspiracji dla osób, które chcą świadomie dbać o swój
          rozwój osobisty
        </strong>
        . Znajdziesz tu artykuły o radzeniu sobie ze stresem, budowaniu
        pozytywnych relacji, pokonywaniu lęków i wielu innych ważnych aspektach
        zdrowia psychicznego.{" "}
        <strong>Dołącz do nas i zainwestuj w siebie!</strong>
      </p>
    </div>
  );
};

export default Banner;
